import PropTypes from "prop-types"
import React from "react"
import { useTranslation } from "react-i18next"
import { Modal, ModalBody } from "reactstrap"

const DeleteModal = ({
  show,
  onDeleteClick,
  onCloseClick,
  buttonText,
  bodyTitle,
  isLoading,
}) => {
  const { t } = useTranslation()

  return (
    <Modal size="md" isOpen={show} toggle={onCloseClick} centered={true} backdrop="static">
      <div className="modal-content">
        <ModalBody className="px-4 py-5 text-center">
          <button
            type="button"
            onClick={onCloseClick}
            className="btn-close position-absolute end-0 top-0 m-3"
          ></button>
          <p className="text-muted font-size-16 mb-4">{bodyTitle}</p>

          <div className="hstack gap-2 justify-content-center mb-0">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onCloseClick}
            >
              {t("Cancel")}
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={onDeleteClick}
              disabled={isLoading}
            >
              {buttonText}
            </button>
          </div>
        </ModalBody>
      </div>
    </Modal>
  )
}

DeleteModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any,
}

export default DeleteModal
